import { render, staticRenderFns } from "./DiseaseDetail.vue?vue&type=template&id=864fdbd6&scoped=true&"
import script from "./DiseaseDetail.vue?vue&type=script&lang=js&"
export * from "./DiseaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseDetail.vue?vue&type=style&index=0&id=864fdbd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864fdbd6",
  null
  
)

export default component.exports